import { useEffect } from "react";

/**
 * Reading Lume - a warm champagne radial glow that follows the cursor
 * across the book stage. Zero React re-renders: updates CSS vars via rAF.
 * Respects reduced motion and skips on coarse pointers.
 */
export default function ReadingLume({ containerRef }) {
  useEffect(() => {
    const el = containerRef?.current;
    if (!el) return;
    if (typeof window === "undefined") return;
    if (window.matchMedia("(pointer: coarse)").matches) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let raf = 0;
    let lastX = 50;
    let lastY = 40;
    el.style.setProperty("--lume-opacity", "0");

    const onMove = (e) => {
      const r = el.getBoundingClientRect();
      lastX = ((e.clientX - r.left) / r.width) * 100;
      lastY = ((e.clientY - r.top) / r.height) * 100;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        el.style.setProperty("--lume-x", `${lastX}%`);
        el.style.setProperty("--lume-y", `${lastY}%`);
        el.style.setProperty("--lume-opacity", "1");
      });
    };
    const onLeave = () => el.style.setProperty("--lume-opacity", "0");

    el.addEventListener("mousemove", onMove);
    el.addEventListener("mouseleave", onLeave);
    return () => {
      el.removeEventListener("mousemove", onMove);
      el.removeEventListener("mouseleave", onLeave);
      cancelAnimationFrame(raf);
    };
  }, [containerRef]);

  return null;
}
